import { PageLoading } from 'module/ui/components/atoms/loading';
import { Outlet, RouteObject, useParams } from '@rocketlane/rocket-router';
import { Routes, Route } from '@rocketlane/rocket-router';
import { useSalesforceConfigByIdQuery } from 'queries/salesforce';
import { ResourceMappings } from 'components/organisms/integrations/salesforce/resource-mappings/resource-mappings';
import { SalesforceSettings } from 'components/organisms/integrations/salesforce/settings/settings';
import { AutomationsListPage } from 'components/pages/integrations/salesforce/automations-list';
import { AutomationCreatePage } from 'components/pages/integrations/salesforce/create';
import { SalesforceEditPage } from 'components/pages/integrations/salesforce/edit';
import { ErrorLogsPage } from 'components/pages/integrations/salesforce/error-logs';
import { AutomaticRedirection } from 'components/pages/integrations/salesforce/redirection';
import { ROUTE_PATHS } from './route-paths';
import { SecureRoute } from './secure-route';

const SalesForceIntegrationsByIdPage = () => {
  const { integrationId } = useParams<{ integrationId: string }>();
  const { isError, data, isLoading, isInitialLoading } =
    useSalesforceConfigByIdQuery(Number(integrationId), {
      enabled: integrationId !== 'new',
      staleTime: 5 * 60 * 1000, // 5 minutes - prevents refetching on tab switch
      gcTime: 10 * 60 * 1000, // 10 minutes - keeps data in cache
    });

  if (integrationId !== 'new' ? isLoading : isInitialLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <AutomaticRedirection />;
  }

  return (
    <Routes>
      <Route
        path={`${ROUTE_PATHS.SALESFORCE_AUTOMATIONS}/${ROUTE_PATHS.MATCH_ALL}`}
        element={<AutomationsListPage />}
      />
      <Route
        path={ROUTE_PATHS.SALESFORCE_FIELD_SYNC}
        element={<ResourceMappings />}
      />
      <Route
        path={ROUTE_PATHS.SALESFORCE_SETTINGS_TAB}
        element={<SalesforceSettings data={data} />}
      />
      <Route
        path={ROUTE_PATHS.SALESFORCE_ERROR_LOGS}
        element={<ErrorLogsPage />}
      />
      <Route path={ROUTE_PATHS.MATCH_ALL} element={<h1>Not found</h1>} />
    </Routes>
  );
};

export const salesforceRoutes: RouteObject = {
  path: 'integrations/salesforce',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: (
        <SecureRoute>
          <AutomaticRedirection />
        </SecureRoute>
      ),
    },
    {
      path: ':integrationId/automations/new',
      element: <AutomationCreatePage />,
    },
    {
      path: ':integrationId/automations/:automationId/edit',
      element: <SalesforceEditPage />,
    },
    {
      path: ':integrationId/*',
      element: <SalesForceIntegrationsByIdPage />,
    },
  ],
};
